import React, { useState } from "react";
import parentShareVideo from "../../assets/parentShareVideo.mp4";
import CustomHeading from "../custom/CustomHeading";
import CustomContent from "../custom/CustomContent";
import dayThumbnail from "../../assets/dayThumbnail.jpg";
import mobileDayThumbnail from "../../assets/mobileDayThumbnail.jpg";
import tabDayThumbnail from "../../assets/tabDayThumbnail.jpg";
import YoutubeModal from "../custom/YoutubeModal";
const DaySection = () => {
  const [youtubeModal, setYoutubeModal] = useState(false);
  return (
    <div className="w-full px-[4%] bg-white lg:gap-[4rem] gap-[2rem] lg:h-[38rem] flex lg:flex-row flex-col justify-between items-center py-[4%]">
      {/* left section */}
      <div className="lg:w-[50%] flex flex-col sm:gap-3 ">
        <CustomHeading
          text={"A Day At"}
          textSize="54px"
          textAlign="left"
          leading={window.innerWidth < 450 ? "42px" : "64px"}
          smTextSize="32px"
        />
        <CustomHeading
          text={"Mother"}
          spanText={"'"}
          thirdTextColor="#d31c4f"
          secondFontStyle="font-Lato"
          thirdText={"s Pride"}
          textSize="54px"
          textAlign="left"
          leading={window.innerWidth < 450 ? "42px" : "64px"}
          showHeart={true}
          textColor="#d31c4f"
          smTextSize="32px"
        />
        <CustomContent
          marginTop="10px"
          textAlign="justify"
          textColor="#636363"
          text={
            "For Mother’s Pride, childhood is a celebration and we ensure that our Prideens make the most of every moment. Everyday offers something new for our children, however, we have a daily routine to provide a structure to their days."
          }
        />
        <ul className="flex gap-[6px] flex-col  font-Lato font-medium text-lg leading-7 text-[#636363]">
          <li className="border border-black rounded-xl w-fit py-[1px] px-3 font-semibold">
            Arrival & Welcome Activity
          </li>
          <li className="border border-black rounded-xl w-fit py-[1px] px-3 font-semibold">
            Assembly
          </li>
          <li className="border border-black rounded-xl w-fit py-[1px] px-3 font-semibold">
            Circle Time
          </li>
          <li className="border border-black rounded-xl w-fit py-[1px] px-3 font-semibold">
            Curricular Activity{" "}
          </li>
          <li className="border border-black rounded-xl w-fit py-[1px] px-3 font-semibold">
            Lunch Time{" "}
          </li>
          <li className="border border-black rounded-xl w-fit py-[1px] px-3 font-semibold">
            Co-curricular Activity
          </li>
          <li className="border border-black rounded-xl w-fit py-[1px] px-3 font-semibold">
            Safe Dispersal
          </li>
        </ul>
      </div>
      {/* right section */}
      <>
        <div
          className="group w-full mx-auto lg:w-[50%] relative cursor-pointer  sm:h-[405px] lg:h-[500px] h-[250px]"
          onClick={() => {
            setYoutubeModal(true);
          }}
        >
          <img
            src={
              window.innerWidth < 450
                ? window.innerWidth < 750
                  ? tabDayThumbnail
                  : mobileDayThumbnail
                : dayThumbnail
            }
            alt={`youtube url`}
            className="w-full sm:h-[405px] lg:h-[500px] h-[250px] rounded-md cursor-pointer "
          />
          <div className="absolute rounded-md inset-0 flex items-center justify-center bg-black bg-opacity-30">
            <svg
              className="w-16 h-16 text-white"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>
        {youtubeModal && (
          <YoutubeModal url={parentShareVideo} setOpenModal={setYoutubeModal} />
        )}
      </>
    </div>
  );
};

export default DaySection;
